const globalReference = {
    uid: {
        about: 'about',
        projects: 'projects',
        contact: 'contact',
    },
    route: {
        about: '/about',
        projects: '/projects',
        contact: '/contact',
    }
}

export default globalReference